<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Name"
    seFeDataSubtitle="A name component"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
      <se-fe-card-content>
        <p>Use this component for combined name inputs</p>
        <p>Uses the following ui-components</p>
        <ul>
          <li>
            <a routerLink="/libs/ui-suffix">&#64;se-po/shared-ui-suffix</a>
          </li>
        </ul>
      </se-fe-card-content>
    </se-fe-card>

    @for (n of models; track n) {
      <se-fe-card>
        <se-fe-card-header [seFeDataTitle]="n"></se-fe-card-header>
        <se-fe-card-content>
          <se-fe-docs-table
            [seFeDataHeaders]="headers[n]"
            [seFeDataRows]="rows[n]">
          </se-fe-docs-table>
        </se-fe-card-content>
      </se-fe-card>
    }

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-name-example></se-po-name-example>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Example Code with Suffix and Preferred Name Enabled"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-suffix-preferred-name-example></se-po-suffix-preferred-name-example>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Pre-filled Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-populated-name-example></se-po-populated-name-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
<se-fe-toast></se-fe-toast>
